import Vue from 'vue'
import VueRouter from 'vue-router'
//
// 重复路由跳转报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

// 模块路由
import AuthRouter from '@/router/modules/auth'
import Organization from '@/router/modules/organization'
import MatchRouter from '@/router/modules/match'
import EventRouter from '@/router/modules/event'
import MerchantRouter from '@/router/modules/merchant'
import ApplyRouter from "@/router/modules/apply";
import UnionMatchRouter from '@/router/modules/union-match'
import MatchManage from '@/router/modules/match-manage'
import MatchTeamGameRouter from '@/router/modules/match-team-game'
import OrgRouter from '@/router/modules/org'
import UserOrgRouter from '@/router/modules/user-org'
import JetlympicRouter from '@/router/modules/jetlympic'
import activityOstenRoutes from '@/router/modules/activity-osten'
import NewMatchDetailRouter from '@/router/modules/new-match-detail'
import QuestionnaireRouter from '@/router/modules/questionnaire'
import UaFlagRouter from '@/router/modules/ua-flag'
import PlayerStatsRouter from '@/router/modules/player-stats'
import QuizRouter from '@/router/modules/quiz'
import NewGameDetailRouter from '@/router/modules/new-game-detail'
const routes = [
  {
    path: '/index',
    name: 'Index',
    meta: { title: '首页' },
    component: () => import(/* webpackChunkName: "Index" */ '@/views/index')
  },
  {
    path: '/match-announcement',
    name: 'MatchAnnouncement',
    meta: { title: '赛事公告' },
    component: () => import('@/views/match-announcement/index')
  },
  {
    path: '/video-test',
    name: 'VideoTest',
    meta: { title: '直播测试页面' },
    component: () => import('@/views/video/index.vue')
  },
  {
    path: '/live-page/:gameId',
    name: 'LivePage',
    meta: { title: '直播页面' },
    component: () => import('@/views/live-page/index')
  },
  AuthRouter,
  Organization,
  MerchantRouter,
  UnionMatchRouter,
  ApplyRouter,
  MatchRouter,
  EventRouter,
  MatchManage,
  MatchTeamGameRouter,
  OrgRouter,
  UserOrgRouter,
  JetlympicRouter,
  ...activityOstenRoutes,
  UaFlagRouter,
  ...NewMatchDetailRouter,
  ...NewGameDetailRouter,
  ...QuestionnaireRouter,
  PlayerStatsRouter,
  ...QuizRouter,
  { path: '*', redirect: '/index' },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
